/**
 * "Asha Patel" → "AP", "Asha" → "A". The first character of the first and the last word, so names in
 * Devanagari work too; no avatar is fetched from anywhere. In the entry graph (the header button) —
 * keep it tiny and dependency-free.
 */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = Array.from(words[0] ?? '')[0] ?? '';
  const last = words.length > 1 ? (Array.from(words[words.length - 1] ?? '')[0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
